module.exports = __webpack_public_path__ + "img/research_3.14382db5.png";